import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';

export default function SiteFooter({ brandName = 'okeybot' }) {
  const year = new Date().getFullYear();

  return (
    <footer className="landing-footer">
      <div className="landing-footer-content">
        <div className="landing-footer-brand">
          <div className="landing-logo">
            <Logo size={32} />
            <span className="landing-logo-text">{brandName}</span>
          </div>
          <p className="landing-footer-tagline">Your AI, Your Rules, Your Keys</p>
        </div>

        <div className="landing-footer-links">
          <div className="landing-footer-section">
            <h4>Product</h4>
            <Link to="/dashboard">Dashboard</Link>
            <Link to="/#features">Features</Link>
            <Link to="/#pricing">Pricing</Link>
          </div>

          <div className="landing-footer-section">
            <h4>Resources</h4>
            <Link to="/docs">Documentation</Link>
            <Link to="/support">Support</Link>
            {/*
              <Link to="/blog">Blog</Link>
            */}
          </div>

          <div className="landing-footer-section">
            <h4>Legal</h4>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
            <a href="/third-party-licenses.txt">Open-Source Licenses</a>
            {/*
              <Link to="/security">Security</Link>
            */}
          </div>
        </div>
      </div>

      <div className="landing-footer-bottom">
        <p>© {year} {brandName}. All rights reserved. <span style={{ whiteSpace: 'nowrap' }}>Made with <span style={{ color: '#ef4444' }}>♥</span> in NYC</span></p>
      </div>
    </footer>
  );
}
